import COMMENT_CONTAINERS from './commentContainers.graphql'
import COMMENT_QUERY from './commentQuery.graphql'
import CREATE_COMMENT  from './createComment.graphql'
import DELETE_COMMENT from './deleteComment.graphql'
import UPDATE_COMMENT from './updateComment.graphql'

export {COMMENT_CONTAINERS, COMMENT_QUERY, CREATE_COMMENT, DELETE_COMMENT, UPDATE_COMMENT}



// WEBPACK FOOTER //
// ./src/modules/common/graphql/notes/index.ts